module.exports = __webpack_public_path__ + "img/Casey Wardynski.51ce9682.jpg";